import { Injectable, signal } from '@angular/core';

const DEFAULT_COLOR = '#2C5591';
const STORAGE_KEY = 'headerBackgroundColor';

@Injectable({ providedIn: 'root' })
export class HeaderColorService {
  readonly color = signal<string>(localStorage.getItem(STORAGE_KEY) ?? DEFAULT_COLOR);

  loadFromBackend(backendColor?: string): void {
    if (!backendColor) {
      this.resetToDefault();
      return;
    }
    this.color.set(backendColor);
    localStorage.setItem(STORAGE_KEY, backendColor);
  }

  resetToDefault(): void {
    this.color.set(DEFAULT_COLOR);
    localStorage.removeItem(STORAGE_KEY);
  }
}
